import firebase from 'firebase';
import _ from 'lodash';

import View from '../_components/view/view.js';
import historySectionTpl from './history-section.tpl.html';
import './history-section.styles.less';

import playersService from '../_services/players.service.js';
import groupsService from '../_services/groups.service.js';

import PositionHistoryView from './position-history/position-history.view.js';

class HistorySectionView extends View {

	constructor (data, options) {
		let viewOptions = {
			viewClass: 'history-section'
		};

		super(historySectionTpl, data, _.extend(options, viewOptions));

		this.historyRef = firebase.database().ref('rounds/');
	}

	uiElements() {
		return _.extend(super.uiElements(), {
			historyTable: '.history-table',
			loaderContainer: '.loader-container'
		});
	}

	render(data) {
		super.render(data);
	}

	initializeEvents() {
		//UI Events
		

		///Database Events
		this.historyRef.once('value', __rounds => {
			window.console.log('Rounds Data received');
			this.__rounds = __rounds;
			this.prepareHistoryInfo();
		});

		firebase.database().ref('/players').once('value', __players => {
			this.__players = __players;
			this.prepareHistoryInfo();
		});

		firebase.auth().onAuthStateChanged( user => {
			this.user = user;
			this.prepareHistoryInfo();
		});
	}

	prepareHistoryInfo() {

		if (!this.__rounds || !this.__players) return;

		this.ui.loaderContainer.addClass('hidden');

		this.historyData = [];

		let
		counter = 1;

		window.console.log(this.__rounds.val());

		this.__rounds.forEach(__round => {
			let 
			dataRound = {},
			round = __round.val(),
			groups = groupsService.toArrayWithIds(round.groups);

			dataRound.index = counter++;
			dataRound.globalStandings = [];
			dataRound.groupsData = [];
			dataRound.playerData = {};

			//window.console.log('===================== ROUND ' + dataRound.index + ' =====================================');

			groups.forEach((group, index) => {
				//let
				//groupPlayers = _.pickBy(this.__players.val(), player => player.groupId === group.groupId);

				//If players in group...
				if (group.players && Object.keys(group.players).length > 0) {
					let
					groupPlayersArray = playersService.toArrayWithIds(group.players),
					groupMatches = _.filter(round.matches, match => match.groupId === group.groupId),
					groupStandings = groupsService.getGroupStandings(groupMatches, groupPlayersArray);

					groupStandings.forEach( (playerData, index) => {
						playerData.groupName = group.name;
						playerData.groupRank = group.rank;
						playerData.groupPosition = index;
						dataRound.playerData[playerData.playerId] = playerData;
					});

					dataRound.groupsData.push({
						groupStandings: groupStandings,
						groupMatches: groupMatches
					});

					dataRound.globalStandings = dataRound.globalStandings.concat(groupStandings);

					//window.console.log('Group ' + group.name + ' Standings: ');
					//window.console.log(groupStandings);
				}
			});

			dataRound.globalStandings.forEach( (playerData, index) => {
				dataRound.playerData.globalPosition = index;
			});

			this.historyData.push(dataRound);

		});

		this.showPositionHistory();

		this.ui.historyTable.removeClass('hidden');
	}

	showPositionHistory() {

		if (this.positionHistory) {
			this.positionHistory.remove();
		}

		this.positionHistory = new PositionHistoryView({
			players: this.__players.val(),
			historyData: this.historyData,
			user: this.user
		});

		this.positionHistory.appendTo(this.ui.historyTable);
	}

	/*removeNewsList() {
		_.forEach(this.newsViews, newView => {
			newView.remove();
		});

		this.newsViews = [];
	}*/

	remove() {
		/*this.removeNewsList();*/
		super.remove();
	}

}

export default HistorySectionView;


// WEBPACK FOOTER //
// ./C:/Users/juanb/Dev/transforma-ping-pong-league/src/history-section/history-section.view.js